import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

import { B2cService } from './auth/services/b2c.service';
import { LoginService } from './service/login.service';
import { AuthguradServiceService } from './authgurad-service.service';
import { environment } from 'src/environments/environment';
import { UserRoleEnum } from '@enums/user-role.enum';
import { LocalStorageService } from '@services/local-storage.service';
import { IconService } from '@services/icons.service';
import { NotificationMessagesService } from '@modules/notification-messages/services/notification-messages.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public isLoggedIn: boolean;
  public currentDate: Date = new Date();
  URL: any;
  public static it;
  public static accessToken;

  flag: boolean;
  userRole: UserRoleEnum = this.localStorageService.getCurrentUserRole() as UserRoleEnum;
  userRoleList: typeof UserRoleEnum = UserRoleEnum;
  canShowNotificationMessages = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private b2cService: B2cService,
    private loginService: LoginService,
    private Authguardservice: AuthguradServiceService,
    private readonly localStorageService: LocalStorageService,
    private readonly iconService: IconService,
    private readonly notificationMessagesService: NotificationMessagesService,
  ) {
    this.Authguardservice.isRoleAllow.subscribe((value) => {
      this.logout();
    });
    this.isLoggedIn = false;
  }

  ngOnInit(): void {
    let a = window.location.href;
    if (environment.isOktSSOEnable == true) this.setFlagIfCalledFromOktaDashboard();

    this.loginService.receivedLoginStatus.subscribe((param: boolean) => {
      this.isLoggedIn = param;
    });

    //TODO: REFACTOR THIS
    if (
      localStorage.getItem('AccessToken') != null &&
      localStorage.getItem('AccessToken') != undefined &&
      localStorage.getItem('user') != null &&
      localStorage.getItem('user') != undefined
    ) {
      this.isLoggedIn = true;
    } else if (
      a.includes('track-itinerary') ||
      a.includes('common-itinerary') ||
      a.includes('service-request-details') ||
      a.includes('privacy-policy')
    ) {
    } else {
      this.router.navigateByUrl('/login');
    }

    if (a.includes('call-flow-details')) {
      this.isLoggedIn = false;
    }
    this.URL = window.location.href.split('#/')[1];
    const urlParams = new URLSearchParams(window.location.search);
    var errorDescription = urlParams.get('error_description');
    var state = urlParams.get('state');
    var code = urlParams.get('code');
    if (urlParams != null) {
      this.cookieService.set('stateFromB2C', state);
      this.cookieService.set('codeFromB2C', code);
      this.cookieService.set('errorFromB2C', errorDescription);
      // Replace the query strings only when coming back from B2C
      if (this.URL == undefined || this.URL == null) {
        window.history.replaceState(null, null, window.location.pathname);
      }
    }

    this.iconService.registerIcons();
    this.notificationMessagesWatcher();
    this.registerMultiselectChipTooltips();
  }

  private registerMultiselectChipTooltips(): void {
    document.addEventListener('mouseover', (event: MouseEvent): void => {
      const chip = (event.target as HTMLElement).closest('.multiselect-dropdown .selected-item');
      if (chip instanceof HTMLElement && !chip.title) {
        chip.title = chip.firstChild?.textContent?.trim() ?? '';
      }
    });
  }

  logout() {
    this.cookieService.deleteAll();
    window.sessionStorage.clear();
    localStorage.clear();
    this.isLoggedIn = false;
    this.cookieService.set('isLogin', 'false');
    window.location.href = this.b2cService.getUrl('signIn');
    localStorage.removeItem('user');
  }
  ngOnDestroy() {
    this.cookieService.deleteAll();
    localStorage.removeItem('isCalledFromOktaDashboard');
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  setFlagIfCalledFromOktaDashboard() {
    let isCalledFromOktaDashboardFlagExists = localStorage.getItem('isCalledFromOktaDashboard');
    isCalledFromOktaDashboardFlagExists == 'false' ? (isCalledFromOktaDashboardFlagExists = null) : '';
    if (isCalledFromOktaDashboardFlagExists == null || isCalledFromOktaDashboardFlagExists == undefined) {
      const currentUrl = window.location.search;
      const isCalledFromOktaDashboard = currentUrl.includes(environment.oktaRedirectUri);
      localStorage.setItem('isCalledFromOktaDashboard', isCalledFromOktaDashboard.toString());
    }
  }

  // todo: this is a crunch for notification messages logic,
  //  we need to check if the user object exists in localStorage, otherwise we'll get the error
  //  due to SignalR service not initialized
  private notificationMessagesWatcher(): void {
    if (this.localStorageService.getCurrentUserDetails()) {
      this.canShowNotificationMessages = true;
    } else {
      const showNotificationMessageSubs = this.notificationMessagesService.showNotificationMessage.subscribe((data) => {
        this.canShowNotificationMessages = data;
      });

      this.subscriptions.push(showNotificationMessageSubs);
    }
  }
}
